import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  class: "swiper product-detail__blog-swiper js-blog-swiper",
  ref: "swiper"
}
const _hoisted_4 = { class: "swiper-slide product-detail__blog-swiper-item" }
const _hoisted_5 = { class: "blog-grid-card" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "blog-grid-card__image-wrap" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "blog-grid-card__content" }
const _hoisted_10 = { class: "blog-grid-card__date mt-3" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "swiper-button-prev product-detail__blog-swiper-prev",
  ref: "prevButton"
}
const _hoisted_14 = {
  class: "swiper-button-next product-detail__blog-swiper-next",
  ref: "nextButton"
}
const _hoisted_15 = {
  key: 0,
  class: "product-detail__blog-spinner fas fa-spinner fa-spin js-modal-spinner"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["swiper-wrapper product-detail__blog-swiper-wrapper js-blog-slide-inject", $setup.isHidden ? 'invisible' : '']),
          ref: "swiperWrapper"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.blogs, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: `${$setup.translations.BlogDetailUrl}/${item?.UrlName}`,
                  class: "product-detail__blog-slider-link"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: item.ImagePath,
                      alt: item.Alt,
                      class: "product-detail__blog-image"
                    }, null, 8 /* PROPS */, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.pubFormattedDate), 1 /* TEXT */),
                    _createElementVNode("div", {
                      class: "blog-grid-card__title product-detail__blog-slider-card__title",
                      innerHTML: item.Title
                    }, null, 8 /* PROPS */, _hoisted_11),
                    _createElementVNode("div", {
                      class: "blog-grid-card__description product-detail__blog-slider-card__description",
                      innerHTML: item.Summary
                    }, null, 8 /* PROPS */, _hoisted_12)
                  ])
                ], 8 /* PROPS */, _hoisted_6)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_13, null, 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_14, null, 512 /* NEED_PATCH */),
        ($setup.isHidden)
          ? (_openBlock(), _createElementBlock("i", _hoisted_15))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */)
    ])
  ]))
}